module.exports = __webpack_public_path__ + "static/media/Солиев Ю.С. (КФА).1b1c12a1.pdf";